import { createActions, createReducer } from 'reduxsauce'

import PortalService from '../servicos/PortalService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaLinksInicio: [],
    buscaLinksSucesso: ['links'],
    buscaLinksErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    links: [],
}

Creators.buscaLinks = () => {
    return dispatch => {
        dispatch(Creators.buscaLinksInicio())
        let serv = new PortalService()
        return serv
            .getLinks()
            .then(response => dispatch(Creators.buscaLinksSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaLinksErro(error)))
    }
}

const buscaLinksInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaLinksErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaLinksSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, links: action.links, carregando: false }
}

export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_LINKS_INICIO]: buscaLinksInicio,
    [Types.BUSCA_LINKS_ERRO]: buscaLinksErro,
    [Types.BUSCA_LINKS_SUCESSO]: buscaLinksSucesso,
})
